import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, Truck, Award, Leaf, CheckCircle2, Star } from 'lucide-react';
import { EnhancedScrollReveal } from '../common/EnhancedScrollReveal';
import { Tooltip } from '../ui/Tooltip';
const pressLogos = [{
  name: 'Vogue',
  url: 'https://upload.wikimedia.org/wikipedia/commons/thumb/6/6c/Vogue_logo.svg/2560px-Vogue_logo.svg.png'
}, {
  name: 'Forbes',
  url: 'https://upload.wikimedia.org/wikipedia/commons/thumb/0/0c/Forbes_logo.svg/2560px-Forbes_logo.svg.png'
}, {
  name: 'Elle',
  url: 'https://upload.wikimedia.org/wikipedia/commons/thumb/e/e6/Elle_logo.svg/2560px-Elle_logo.svg.png'
}, {
  name: 'National Geographic',
  url: 'https://upload.wikimedia.org/wikipedia/commons/thumb/6/67/National_Geographic_Logo.svg/2560px-National_Geographic_Logo.svg.png'
}, {
  name: 'Vanity Fair',
  url: 'https://upload.wikimedia.org/wikipedia/commons/thumb/a/a8/Vanity_Fair_logo.svg/2560px-Vanity_Fair_logo.svg.png'
}];
const indicators = [{
  icon: ShieldCheck,
  title: 'Garantía 100%',
  desc: '30 días de prueba',
  detail: 'Si no notas la diferencia, te devolvemos el dinero.',
  color: 'text-emerald-600',
  bg: 'bg-emerald-50'
}, {
  icon: Truck,
  title: 'Envío Gratis',
  desc: 'Pedidos +49€',
  detail: 'Entrega refrigerada en 24/48h en toda la península.',
  color: 'text-blue-600',
  bg: 'bg-blue-50'
}, {
  icon: Award,
  title: 'Vet Approved',
  desc: 'Formulado por expertos',
  detail: 'Recetas desarrolladas por nuestro equipo veterinario.',
  color: 'text-purple-600',
  bg: 'bg-purple-50'
}, {
  icon: Leaf,
  title: '100% Natural',
  desc: 'Grado humano',
  detail: 'Sin subproductos, harinas ni conservantes artificiales.',
  color: 'text-amber-600',
  bg: 'bg-amber-50'
}];
export function TrustIndicators() {
  return <section className="py-16 bg-white border-b border-gray-100 overflow-hidden" data-id="element-3633">
      <div className="container-custom max-w-7xl mx-auto" data-id="element-3634">
        {/* Main Indicators Grid */}
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 lg:gap-12 mb-16" data-id="element-3635">
          {indicators.map((item, index) => <EnhancedScrollReveal key={index} delay={index * 0.1} className="flex items-center gap-4 group cursor-help p-4 rounded-2xl hover:bg-gray-50 transition-colors" data-id="element-3636">
              <Tooltip content={item.detail} data-id="element-3637">
                <div className={`w-12 h-12 rounded-2xl ${item.bg} flex items-center justify-center shrink-0 transition-transform duration-300 group-hover:scale-110 group-hover:rotate-3 shadow-sm`} data-id="element-3638">
                  <item.icon className={`w-6 h-6 ${item.color}`} data-id="element-3639" />
                </div>
              </Tooltip>
              <div data-id="element-3640">
                <h3 className="font-bold text-charcoal-900 group-hover:text-primary-700 transition-colors text-sm md:text-base" data-id="element-3641">
                  {item.title}
                </h3>
                <p className="text-xs md:text-sm text-charcoal-500 font-medium" data-id="element-3642">
                  {item.desc}
                </p>
              </div>
            </EnhancedScrollReveal>)}
        </div>

        {/* Press Marquee */}
        <div className="relative pt-8 border-t border-gray-100" data-id="element-3643">
          <div className="text-center mb-8" data-id="element-3644">
            <span className="text-[10px] font-bold text-gray-400 uppercase tracking-[0.2em]" data-id="element-3645">
              Reconocidos por la excelencia
            </span>
          </div>

          <div className="flex flex-wrap justify-center items-center gap-8 md:gap-16 opacity-40 grayscale hover:grayscale-0 transition-all duration-700" data-id="element-3646">
            {pressLogos.map((logo, i) => <img key={i} src={logo.url} alt={logo.name} className="h-6 md:h-8 object-contain hover:scale-110 transition-transform duration-300" data-id="element-3647" />)}
          </div>
        </div>

        {/* Trust Badge Strip */}
        <div className="mt-12 flex flex-wrap justify-center gap-4 md:gap-8" data-id="element-3648">
          <div className="flex items-center gap-2 px-4 py-2 bg-gray-50 rounded-full border border-gray-100 text-xs font-bold text-gray-600" data-id="element-3649">
            <CheckCircle2 className="w-4 h-4 text-primary-600" data-id="element-3650" />
            Certificado ISO 9001
          </div>
          <div className="flex items-center gap-2 px-4 py-2 bg-gray-50 rounded-full border border-gray-100 text-xs font-bold text-gray-600" data-id="element-3651">
            <CheckCircle2 className="w-4 h-4 text-primary-600" data-id="element-3652" />
            HACCP Control
          </div>
          <div className="flex items-center gap-2 px-4 py-2 bg-gray-50 rounded-full border border-gray-100 text-xs font-bold text-gray-600" data-id="element-3653">
            <Star className="w-4 h-4 text-amber-500 fill-amber-500" data-id="element-3654" />
            4.9/5 en Trustpilot
          </div>
        </div>
      </div>
    </section>;
}